<template>
  <div>
    <h2>店舗カセット</h2>
    <div class="store-input-form" v-if="isEditing">
      <div class="container">
        <div class="form-group container__item">
          <label>
            <p>店舗名</p>
            <input type="text" v-model="store.name" />
          </label>
          <label>
            <p>説明文</p>
            <input type="text" v-model="store.description" />
          </label>
          <label>
            <p>住所(optional)</p>
            <input type="text" v-model="store.address" />
          </label>
          <label>
            <p>価格(optional)</p>
            <input type="text" v-model="store.price" />
          </label>
          <label>
            <p>スコア</p>
            <input type="number" min="1" max="5" v-model="store.score" />
          </label>

          <label>
            <p>関連リンク</p>
          </label>
          <button v-if="store.relatedLinks.length < 5" @click="addLink">
            追加
          </button>
          <div>
            <ul>
              <li v-for="(link, index) in store.relatedLinks" :key="index">
                <p>url: <input type="text" v-model="link.url" /></p>
                <p>title: <input type="text" v-model="link.title" /></p>
                <button @click="removeLink(index)">削除</button>
              </li>
            </ul>
          </div>
        </div>
        <div class="form-group container__item">
          <ul class="editing-images">
            <li
              v-for="(img, i) in store.images"
              :key="i"
              class="editing-images__item"
            >
              <img :src="img.url" alt="" />
              <button @click="removeImage(i)" class="editing-images__remove">
                <i class="fa fa-close"></i>
              </button>
            </li>
          </ul>
          <image-uploader @add="addImage" />
        </div>
      </div>
      <div class="form-group__footer">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="store-input-preview input-preview" v-else>
      <div class="store">
        <div class="store__head">
          <time>{{ formattedDate }}</time>
          <div class="store__score">
            <p class="store__score-star">
              {{ stars }}
            </p>
            <p>({{ store.score }})</p>
          </div>
        </div>

        <p class="store__text">店舗名: {{ store.name }}</p>
        <p class="store__text">説明: {{ store.description }}</p>
        <p v-if="store.address" class="store__text">
          住所: {{ store.address }}
        </p>
        <p v-if="store.price" class="store__text">価格: {{ store.price }}</p>
        <div class="store__links">
          <p>関連リンク</p>
          <ul v-if="store.relatedLinks.length > 0">
            <li
              v-for="(link, i) in store.relatedLinks"
              :key="i"
              class="store__link-item"
            >
              <p>title: {{ link.title }}</p>
              <p>url: {{ link.url }}</p>
            </li>
          </ul>
          <p v-else class="store__link-empty">なし</p>
        </div>
        <div class="store__links">
          <p>画像</p>
          <ul v-if="store.images.length > 0" class="store__images">
            <li v-for="(img, i) in store.images" :key="i" class="store__image">
              <img :src="img.url" :alt="img.alt" />
            </li>
          </ul>
          <p v-else class="store__link-empty">なし</p>
        </div>
      </div>
      <footer-menu
        :onDeleteInput="onDeleteInput"
        :onBeginEdit="onBeginEdit"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import FooterMenu from '../input-footer-menu.vue';
import ImageUploader from './ImageUploader.vue';

const SCORE_MAX = 5;

export default {
  name: 'StoreEditor',
  components: {
    FooterMenu,
    ImageUploader,
  },
  props: {
    value: Object,
    index: Number,
    id: String,
  },
  data() {
    return {
      isEditing: false,
      isUploading: false,
      store: {
        name: this.value.name,
        description: this.value.description,
        address: this.value.address,
        price: this.value.price,
        score: this.value.score,
        images: this.value.images,
        relatedLinks: this.value.related_links,
        created_at: this.value.created_at
          ? new Date(this.value.created_at)
          : new Date(),
      },
    };
  },
  computed: {
    stars() {
      return '★'.repeat(this.store.score).padEnd(SCORE_MAX, '☆');
    },
    formattedDate() {
      const d = this.store.created_at;
      return `${d.getFullYear()}/${
        d.getMonth() + 1
      }/${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
    },
    bodyJSON() {
      const value = {
        name: this.store.name,
        description: this.store.description,
        address: this.store.address,
        price: this.store.price,
        score: this.store.score,
        images: this.store.images,
        related_links: this.store.relatedLinks,
      };

      if (!value.price) {
        delete value.price;
      }
      if (!value.address) {
        delete value.address;
      }

      return {
        value,
        action: 'store',
        id: this.id,
      };
    },
    editorOptions() {
      return {
        modules: {
          table: true,
          toolbar,
        },
      };
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      this.store.score = Math.min(Math.max(this.store.score, 0), SCORE_MAX);
      this.store.relatedLinks = this.store.relatedLinks.filter(
        ({ title, url }) => title || url
      );

      if (this.store.name.length === 0) {
        alert('店舗名を入力してください');
        return false;
      }
      if (this.store.description.length === 0) {
        alert('説明を入力してください');
        return false;
      }
      if (this.store.relatedLinks.some((link) => link.title.length === 0)) {
        alert('関連リンクのタイトルを入力してください');
        return false;
      }
      if (this.store.relatedLinks.some((link) => link.url.length === 0)) {
        alert('関連リンクのURLを入力してください');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
    addLink() {
      this.store.relatedLinks = [
        ...this.store.relatedLinks,
        {
          url: '',
          title: '',
        },
      ];
    },
    removeLink(index) {
      this.store.relatedLinks = this.store.relatedLinks.filter(
        (_, i) => i !== index
      );
    },
    addImage(img) {
      this.store.images = [...this.store.images, img];
    },
    removeImage(index) {
      this.store.images = this.store.images.filter((_, i) => i !== index);
    },
  },
};
</script>

<style lang="scss" scoped>
.store-input-form {
  background-color: #eee;
  position: relative;
  padding: 15px 15px 1px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}

.container {
  display: flex;
  flex-direction: row;
  gap: 12px;

  &__item {
    flex-basis: 50%;
  }
}

.form-group {
  &__item {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }

  &__footer {
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.ql-editor {
  font-size: 15px;
}

.store {
  border: 1px solid lightgrey;
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;

  &__head {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__score {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__score-star {
    color: #fab704;
  }

  &__text {
    margin-top: 12px;
  }

  &__links {
    margin-top: 12px;
  }

  &__link-item {
    margin-top: 8px;
    margin-left: 12px;

    &:nth-child(n + 2) {
      border-top: 1px dotted gray;
      padding-top: 8px;
    }
  }

  &__link-empty {
    margin-top: 8px;
    margin-left: 12px;
  }
  &__images {
    display: flex;
    height: 100px;
    gap: 2px;
  }
  &__image {
    width: 120px;
    height: 100px;
    margin-top: 2px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.editing-images {
  display: flex;

  &__item {
    position: relative;
    max-width: 100px;
    height: 100px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__remove {
    position: absolute;
    right: 4px;
    top: 4px;
    width: 15px;
    height: 15px;
    display: flex;
    padding-bottom: 2px;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
    background-color: white;
    font-size: 12px;
    border-radius: 50%;
    cursor: pointer;
  }
}
</style>
